(function () {
  const wrap = document.querySelector('.blog-filter-wrap');
  if (!wrap) return;

  const blogUrl = wrap.dataset.blogUrl;
  const rawTags = wrap.dataset.currentTags || '';
  let currentTags = rawTags ? rawTags.split('+').filter(Boolean) : [];
  let isFetching = false;

  const sortLabels = {
    'date-desc': 'Recently added',
    'date-asc':  'Oldest',
    'title-asc': 'Title A\u2013Z',
    'title-desc': 'Title Z\u2013A'
  };

  let currentSort = sessionStorage.getItem('blog-sort') || 'date-desc';

  const chipsContainer = document.getElementById('blog-active-filters');

  // ── AJAX ───────────────────────────────────────────────────────

  function fetchResults(url) {
    if (isFetching) return;
    isFetching = true;

    const results = document.getElementById('blog-results');
    results.style.opacity = '0.4';
    results.style.pointerEvents = 'none';

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newResults = doc.getElementById('blog-results');
        if (newResults) {
          results.innerHTML = newResults.innerHTML;
          applySort(currentSort, false);
        }
        history.pushState({ tags: currentTags.slice() }, '', url);
      })
      .catch(function () {})
      .finally(function () {
        const results = document.getElementById('blog-results');
        results.style.opacity = '';
        results.style.pointerEvents = '';
        isFetching = false;
      });
  }

  function buildTagUrl(tags) {
    if (!tags.length) return blogUrl;
    return blogUrl + '/tagged/' + tags.join('+');
  }

  // ── Sort ───────────────────────────────────────────────────────

  function applySort(sort, save) {
    const container = document.querySelector('.blog-articles');
    if (container) {
      const items = Array.from(container.querySelectorAll('.blog-articles__article'));
      items.sort(function (a, b) {
        if (sort === 'date-desc') return Number(b.dataset.date) - Number(a.dataset.date);
        if (sort === 'date-asc')  return Number(a.dataset.date) - Number(b.dataset.date);
        if (sort === 'title-asc') return a.dataset.title.localeCompare(b.dataset.title);
        if (sort === 'title-desc') return b.dataset.title.localeCompare(a.dataset.title);
        return 0;
      });
      items.forEach(function (item) { container.appendChild(item); });
    }

    if (save) {
      currentSort = sort;
      sessionStorage.setItem('blog-sort', sort);
      document.querySelectorAll('.blog-sort-btn').forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.dataset.sort === sort);
      });
      renderChips();
      const dd = document.getElementById('blog-sort-dropdown');
      if (dd) dd.removeAttribute('open');
    }
  }

  // ── Tags ───────────────────────────────────────────────────────

  function toggleTag(tag) {
    const idx = currentTags.indexOf(tag);
    if (idx === -1) currentTags.push(tag);
    else currentTags.splice(idx, 1);

    updateTagBtnStates();
    renderChips();
    fetchResults(buildTagUrl(currentTags));

    const dd = document.getElementById('blog-tag-dropdown');
    if (dd) dd.removeAttribute('open');
  }

  function removeTag(tag) {
    currentTags = currentTags.filter(function (t) { return t !== tag; });
    updateTagBtnStates();
    renderChips();
    fetchResults(buildTagUrl(currentTags));
  }

  function updateTagBtnStates() {
    document.querySelectorAll('.blog-tag-btn').forEach(function (btn) {
      btn.classList.toggle('is-selected', currentTags.indexOf(btn.dataset.tag) !== -1);
    });
  }

  // ── Chips ──────────────────────────────────────────────────────

  function renderChips() {
    chipsContainer.innerHTML = '';

    if (currentSort !== 'date-desc') {
      chipsContainer.appendChild(makeChip('Sort: ' + sortLabels[currentSort], function () {
        applySort('date-desc', true);
      }));
    }

    currentTags.forEach(function (tag) {
      const btn = document.querySelector('.blog-tag-btn[data-tag="' + tag + '"]');
      const label = btn ? btn.dataset.tagLabel : tag;
      chipsContainer.appendChild(makeChip('Type: ' + label, function () {
        removeTag(tag);
      }));
    });
  }

  function makeChip(text, onRemove) {
    const chip = document.createElement('div');
    chip.className = 'blog-active-chip';
    const span = document.createElement('span');
    span.textContent = text;
    const btn = document.createElement('button');
    btn.className = 'blog-active-chip__remove';
    btn.setAttribute('aria-label', 'Remove filter');
    btn.textContent = '\u00d7';
    btn.addEventListener('click', onRemove);
    chip.appendChild(span);
    chip.appendChild(btn);
    return chip;
  }

  // ── Event listeners ────────────────────────────────────────────

  document.querySelectorAll('.blog-sort-btn').forEach(function (btn) {
    btn.addEventListener('click', function () { applySort(this.dataset.sort, true); });
  });

  document.querySelectorAll('.blog-tag-btn').forEach(function (btn) {
    btn.addEventListener('click', function () { toggleTag(this.dataset.tag); });
  });

  document.addEventListener('click', function (e) {
    document.querySelectorAll('.blog-filter-dropdown[open]').forEach(function (el) {
      if (!el.contains(e.target)) el.removeAttribute('open');
    });
  });

  window.addEventListener('popstate', function (e) {
    currentTags = (e.state && e.state.tags) ? e.state.tags : [];
    updateTagBtnStates();
    renderChips();
    fetchResults(buildTagUrl(currentTags));
  });

  // ── Init ───────────────────────────────────────────────────────

  applySort(currentSort, false);
  document.querySelectorAll('.blog-sort-btn').forEach(function (btn) {
    btn.classList.toggle('is-selected', btn.dataset.sort === currentSort);
  });
  renderChips();
})();

